var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["intl-shipping-information-table.j2"] = require( "intl-shipping-information-table.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/intl-shipping-information.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"dom-intl-shipping\">\n    <div class=\"o-row\">\n        <div class=\"o-column o-extra-small--12 o-medium--4 u-no-gutters\">\n            <form novalidate action=\"#\" method=\"post\" class=\"c-form\">\n                <div class=\"c-form__field\">\n                    <select name=\"shipping-country-select\" id=\"shipping-country-select\" class=\"c-form__select js-shipping-country-select\" data-qa-help-shipping-country-select>\n                         <optgroup label=\"";
output += runtime.suppressValue((lineno = 6, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shipping_information-frequently-selected-label"])), env.opts.autoescape);
output += "\">\n                            ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "frequentlySelectedCountries");
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("country", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n                                <option ";
if(runtime.memberLookup((t_4),"country") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"selectedCountry")),"country")) {
output += "selected";
;
}
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"country"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_4),"country"), env.opts.autoescape);
output += "</option>\n                            ";
;
}
}
frame = frame.pop();
output += "\n                         </optgroup>\n                         <optgroup label=\"";
output += runtime.suppressValue((lineno = 11, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["shipping_information-all-other-countries-label"])), env.opts.autoescape);
output += "\">\n                            ";
frame = frame.push();
var t_7 = runtime.contextOrFrameLookup(context, frame, "allOtherCountries");
if(t_7) {var t_6 = t_7.length;
for(var t_5=0; t_5 < t_7.length; t_5++) {
var t_8 = t_7[t_5];
frame.set("country", t_8);
frame.set("loop.index", t_5 + 1);
frame.set("loop.index0", t_5);
frame.set("loop.revindex", t_6 - t_5);
frame.set("loop.revindex0", t_6 - t_5 - 1);
frame.set("loop.first", t_5 === 0);
frame.set("loop.last", t_5 === t_6 - 1);
frame.set("loop.length", t_6);
output += "\n                                <option ";
if(runtime.memberLookup((t_8),"country") == runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "help")),"selectedCountry")),"country")) {
output += "selected";
;
}
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_8),"country"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_8),"country"), env.opts.autoescape);
output += "</option>\n                            ";
;
}
}
frame = frame.pop();
output += "\n                         </optgroup>\n                    </select>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    ";
env.getTemplate("intl-shipping-information-table.j2", false, "help/templates/intl-shipping-information.j2", null, function(t_11,t_9) {
if(t_11) { cb(t_11); return; }
t_9.render(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
output += t_10
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/intl-shipping-information.j2"] , dependencies)